exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".duration-wrapper{border:1px solid #cad2dd;border-radius:5px}.min-date-control{width:50%;display:inline-block}.min-date-control .form-control{margin-top:0}.max-date-control{width:50%;display:inline-block}.max-date-control .form-control{margin-top:0}.calendar-icon{width:20%;display:inline-block;text-align:center}.datepicker-container{width:80%;display:inline-block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/SettingsModal/DurationGroup.scss
 ** module id = 755
 ** module chunks = 0
 **/